import { TextButton } from '@twistopayments/design-system/components/atoms/button'
import { Container } from '@twistopayments/design-system/components/atoms/container'
import { Link } from '@twistopayments/design-system/components/atoms/link'
import { Typography } from '@twistopayments/design-system/components/atoms/typography'
import {
  EmailIcon,
  PhoneIcon,
} from '@twistopayments/design-system/icons/inline'

import type { SectionsMediaArticleContactComponent } from '@twisto/api-cms'

import { HighlightedTitle } from '../../molecules/highlighted-title'

import * as styles from './media-article-contact.styles'

export const MediaArticleContact = ({
  title,
  infoBlockDescription,
  contactLabel,
  contactName,
  contactNumber,
  contactMail,
  infoBlockLink,
  infoBlockTitle,
  highlighted,
}: SectionsMediaArticleContactComponent) => (
  <Container as="section" size="large">
    <HighlightedTitle
      align="center"
      css={styles.title}
      highlighted={highlighted}
      title={title}
    />

    <div css={styles.containersWrapper}>
      <div css={styles.contactContainer}>
        <Typography css={styles.contact} variant="h2">
          {contactName}
          <Typography css={styles.contactLabel}>{contactLabel}</Typography>
        </Typography>
        <Typography css={styles.contactInfo} variant="h3">
          <PhoneIcon color="actionPrimary" />
          <Link css={styles.contactLink} href={`tel:${contactNumber}`}>
            {contactNumber}
          </Link>
        </Typography>
        <Typography css={styles.contactInfo} variant="h3">
          <EmailIcon color="actionPrimary" />
          <Link css={styles.contactLink} href={`mailto:${contactMail}`}>
            {contactMail}
          </Link>
        </Typography>
      </div>

      <div css={styles.infoContainer}>
        <Typography css={styles.infoTitle} variant="h3">
          {infoBlockTitle}
        </Typography>
        <Typography css={styles.infoDescription}>
          {infoBlockDescription}
        </Typography>

        {infoBlockLink?.link && infoBlockLink.text && (
          <TextButton
            css={styles.infoLink}
            target="_blank"
            to={infoBlockLink.link}
            variant="inverted"
          >
            {infoBlockLink.text}
          </TextButton>
        )}
      </div>
    </div>
  </Container>
)
